<template>
  <div v-if="schedule" style="font-size:14px">
    <v-calendar ref="calendar" class="date-picker px-0" is-expanded :attributes="attributes"/>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Summary from '@/models/Summary';
import { mapState } from 'vuex';
export default {
  name: 'TestSchedule',
  components: {},
  props: [],
  data: () => ({
    TAG: 'TestSchedule :',
    schedule: undefined,
    attributes: []
  }),
  computed: {
    ...mapState('training', ['training'])
  },
  methods: {
    async load () {
      if (!this.training._id) return
      const query = { training: this.training._id }
      this.schedule = await Summary.getTestSchedule(query)

      this.attributes = [
        { key: 'today', highlight: 'purple', dates: new Date() }
      ]

      for (const date in this.schedule.testSchedule) {
        const tests = this.schedule.testSchedule[date]
        tests.forEach(label => {
          this.attributes.push({
            key: 'testday:' + label, highlight: 'red', dates: date, popover: { label }
          })
        })
      }
    }
  },
  watch: { training () { this.load() } },
  created () { this.load() }
}
</script>
